import { render, staticRenderFns } from "./materialDialog.vue?vue&type=template&id=664950ac&scoped=true&"
import script from "./materialDialog.vue?vue&type=script&lang=js&"
export * from "./materialDialog.vue?vue&type=script&lang=js&"
import style0 from "./materialDialog.vue?vue&type=style&index=0&id=664950ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664950ac",
  null
  
)

export default component.exports